import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError, of, timer } from 'rxjs';

import { HttpResponse } from '../models/httpResponse';
import { environment } from '../../environments/environment';
import { map, catchError, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { TokenService } from './token.service';
import { UtilService } from './util.service';
import { HttpParams } from '@angular/common/http';
import { BROWSER_API_URL } from '../consts/appConsts';
import { LoggerService } from './logger.service';

const PAYMENT_EVENT_TOKEN_KEY = 'eventToken';
@Injectable({
    providedIn: 'root',
})
export class HttpHelpersService {
    apiUrl = environment.baseApi;
    initDelay = environment.httpInitDelay;
    constructor(
        private http: HttpClient,
        private token: TokenService,
        private util: UtilService,
        private loggerService: LoggerService
    ) {
        setTimeout(() => {
            this.initDelay = 0;
        }, this.initDelay);
    }
    handleError(errorResponse, method?): Observable<any> {
        this.loggerService.log('Ajax Error', `method:${method},${errorResponse.Error}`);
        throw errorResponse;
    }
    ajax(
        httpMethod: string,
        customParams,
        customUrl?: string,
        headers?,
        isBody?,
        baseApi?
    ): Observable<any> {
        const apiUrl = baseApi || this.apiUrl;
        let url = `${apiUrl}${BROWSER_API_URL}`;
        if (customUrl) {
            url = `${apiUrl}${customUrl.trim()}`;
        }
        const params = this.setParams(customParams, apiUrl);
        let options: object;
        if (!isBody) {
            options = {
                params: params,
            };
        } else {
            options = {
                body: this.convertToBody(params),
            };
        }
        if (headers) {
            options['headers'] = headers;
        }
        // timer is workaround for dev environment reload loop
        return timer(this.initDelay).pipe(
            switchMap(() =>
                this.http.request<HttpResponse>(httpMethod, url, options).pipe(
                    map(response => {
                        // if (response.errorCode !== 0 || !response.isValid) {
                        //     throw this.handleError(response, params.method);
                        // }
                        return response.Response || response;
                    }),
                    catchError((err: any, caught: Observable<any>) => {
                        if (err.code) {
                            this.loggerService.log(
                                'Generic network Error',
                                `${err.code}, method:${params.method},${err.message}`
                            );
                            return of(null);
                        } else {
                            throw err;
                        }
                    })
                )
            )
        );
    }
     googleAjax(
        httpMethod: string,
        customParams,
        customUrl?: string,
        headers?,
        isBody?,
        baseApi?
    ): Observable<any> {
        const apiUrl = baseApi || this.apiUrl;
        let url = `${apiUrl}`;
        // if (customUrl) {
        //     url = `${apiUrl}${customUrl}`;
        // }
        const params = this.util.cleanObject(customParams);
        //const params = this.setParams(customParams, apiUrl);
        let options: object;
        if (!isBody) {
            options = {
                albumId: customParams,
            };
        } else {
            options = {
                body: this.convertToBody(params),
            };
        }
        if (headers) {
            options['headers'] = headers;
        }
        // timer is workaround for dev environment reload loop
        return timer(this.initDelay).pipe(
            switchMap(() =>
                this.http.request<any>(httpMethod, url, options).pipe(
                    map(response => {
                        if (!response) {
                            throw this.handleError(response, params.method);
                        }
                
                        return response;
                    }),
                    catchError((err: any, caught: Observable<any>) => {
                        if (err.code) {
                            this.loggerService.log(
                                'Generic network Error',
                                `${err.code}, method:${params.method},${err.message}`
                            );
                            return of(null);
                        } else {
                            throw err;
                        }
                    })
                )
            )
        );
    }
    private setParams(customParams, apiUrl) {
        let params = {
            token: this.token.token,
            event_token: this.token.event_token,
            device_type: 'web',
            lang: 'he',
        };
        if (customParams) {
            params = { ...params, ...customParams };
        }
        if (apiUrl === environment.basePaymentApi) {
            params[PAYMENT_EVENT_TOKEN_KEY] = params.event_token;
            params.event_token = '';
        }
        return this.util.cleanObject(params);
    }

    private convertToBody(params) {
        if (!params) {
            return '';
        }
        let body = new HttpParams();
        Object.keys(params).forEach(key => {
            body = body.append(key, params[key]);
        });
        return body.toString();
    }
}
